/* eslint-disable */
import React, { forwardRef, useMemo } from 'react'

import QRCode from 'qrcode.react'
import imagemAssinatura from 'src/assets/imagens/imagem-assinatura.png'
import logoCertificado from 'src/assets/imagens/logo-certificado.png'
import parteLateralCertificado from 'src/assets/imagens/parte-lateral-certificado.png'
import { FuncoesDataHora } from 'src/componentes'
import { RotasApp } from 'src/rotas'
import { DadosCertificado } from 'src/servicos/api/sala-aula/tipos'

import SalaAulaContainer from '../container'
import {
  nomeCertificadoEstaVazio,
  textoNomeNoCertificado
} from './nome-preview'
import {
  ContainerCertificado,
  ContainerCertificadoVerso,
  LogoLateralCertificado,
  ConteudoCertificado,
  RodapeCertificado,
  Assinatura,
  AssinaturaNome,
  AssinaturaCargo,
  ContainerQRCode,
  ConteudoCertificadoVerso,
  ConteudoCentralizadoCertificado,
  ConteudoCentralizadoCertificadoVerso,
  RodapeCertificadoVerso,
  ContainerLogoCertificadoVerso,
  TituloCertificado
} from './styles'

export const CertificadoLegadoTemplate = forwardRef<
  HTMLDivElement,
  { certificado: DadosCertificado; dataEmissao?: string }
>(({ certificado, dataEmissao }, ref) => {
  const { idMatricula } = SalaAulaContainer.useContainer()
  const urlQRCode = useMemo(
    () =>
      `${process.env.REACT_APP_URL}${RotasApp.ValidacaoCertificado}/${idMatricula}`,
    [idMatricula]
  )

  const dataGeracao = dataEmissao ? new Date(dataEmissao) : null
  const dataCorte = new Date(2025, 4, 5)

  if (dataGeracao) {
    dataGeracao.setHours(0, 0, 0, 0)
  }
  dataCorte.setHours(0, 0, 0, 0)

  return (
    <div ref={ref}>
      <ContainerCertificado>
        <LogoLateralCertificado src={parteLateralCertificado} />
        <ConteudoCertificado>
          <ConteudoCentralizadoCertificado>
            <img src={logoCertificado} alt="Faculdade iPGS" />
            <TituloCertificado>Certificado</TituloCertificado>
            <p>A Faculdade iPGS, no uso de suas atribuições certifica que</p>
            <p
              className={
                nomeCertificadoEstaVazio(certificado.nome)
                  ? 'nome-usuario nome-placeholder'
                  : 'nome-usuario'
              }
            >
              <strong>{textoNomeNoCertificado(certificado.nome)}</strong>
            </p>
            {dataGeracao && dataGeracao < dataCorte ? (
              <p>
                realizou o Curso Livre {certificado.nomeCurso}, com carga
                horária de {certificado.cargaHoraria} horas.
              </p>
            ) : (
              <p>
                realizou o curso {certificado.nomeCurso}, com carga horária de{' '}
                {certificado.cargaHoraria} horas.
              </p>
            )}
            <p>
              Período: {FuncoesDataHora.novaData(certificado.dataInscricao)} à{' '}
              {FuncoesDataHora.novaData(certificado.dataAprovacao)}
            </p>
            <p className="localidade-data">
              Porto Alegre,{' '}
              {FuncoesDataHora.dataFormatadaMesEscrito(new Date())}
            </p>
          </ConteudoCentralizadoCertificado>
          <RodapeCertificado>
            <Assinatura>
              <img src={imagemAssinatura} alt="Assinatura" />
              <p className="linha-absolut">
                __________________________________
              </p>
              <AssinaturaNome>Dra. Aline P. Schneider</AssinaturaNome>
              <AssinaturaCargo>
                Diretora Geral da Faculdade iPGS
              </AssinaturaCargo>
            </Assinatura>
            <ContainerQRCode>
              <QRCode value={urlQRCode} includeMargin />
            </ContainerQRCode>
          </RodapeCertificado>
        </ConteudoCertificado>
      </ContainerCertificado>
      <ContainerCertificadoVerso>
        <LogoLateralCertificado src={parteLateralCertificado} />
        <ConteudoCertificadoVerso>
          <ConteudoCentralizadoCertificadoVerso>
            <h1>ASSUNTOS ABORDADOS NESTE CURSO:</h1>
            <h2>{certificado.nomeCurso}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: certificado.versoCertificado }}
            />
          </ConteudoCentralizadoCertificadoVerso>
          <RodapeCertificadoVerso>
            <QRCode value={urlQRCode} includeMargin />
            <ContainerLogoCertificadoVerso>
              <img src={logoCertificado} alt="Faculdade iPGS" />
            </ContainerLogoCertificadoVerso>
          </RodapeCertificadoVerso>
        </ConteudoCertificadoVerso>
      </ContainerCertificadoVerso>
    </div>
  )
})
